import React, { useState, useEffect } from 'react'
import { Layout, Menu } from 'antd'
import styled from 'styled-components'
import { Link, useLocation } from 'react-router-dom'

import logo from 'assets/images/svg/logo.svg'
import menuIcon from 'assets/images/png/hamburger.png'

const { Header } = Layout

const HeaderComponent = (props) => {
  const [activeMenu, setActiveMenu] = useState(props.path)
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)
  const location = useLocation()

  useEffect(() => {
    setActiveMenu(props.path)
  }, [props.path])

  useEffect(() => {
    window.addEventListener('resize', handleResize)
  }, [])

  document.addEventListener('scroll', (_) => {
    if (window.scrollY >= 35) {
      document.getElementById('Navbar').classList.add('bg')
    } else {
      document.getElementById('Navbar').classList.remove('bg')
    }
  })

  const onChangToMenu = (e) => {
    setActiveMenu(e.key)
    window.scrollTo(0, 0)
  }

  const handleResize = () => {
    setWindowWidth(window.innerWidth)
  }

  const menu = [
    {
      key: '/course-introduction',
      name: 'แนะนำหลักสูตร',
    },
    {
      key: '/enrollment',
      name: 'การลงทะเบียนเรียน',
    },
    {
      key: '/leave-conditions',
      name: 'เงื่อนไขการลา',
    },
    {
      key: '/contact-cooperative-education',
      name: 'การปฏิบัติงานสหกิจศึกษา',
    },
    {
      key: '/university-service',
      name: 'การให้บริการมหาวิทยาลัย',
    },
    {
      key: '/questions',
      name: 'คำถามที่ถามบ่อย',
    },
  ]

  return (
    <CustomHeader id='Navbar'>
      {location.pathname !== '/' && (
        <div style={{ margin: '10px 0', display: 'flex', maxWidth: '180px' }}>
          <Link to='/'>
            <img
            loading="lazy"
              onClick={() => window.scrollTo(0, 0)}
              src={logo}
              alt='logo header'
              style={{ width: '100%', maxHeight: '100px', padding: '0 10px' }}
            />
          </Link>
        </div>
      )}

      {windowWidth > 414 && location.pathname === '/' && (
        <div style={{ margin: '10px 0', display: 'flex', maxWidth: '180px' }}>
          <Link to='/'>
            <img
            loading="lazy"
              onClick={() => window.scrollTo(0, 0)}
              src={logo}
              alt='logo header'
              style={{ width: '100%', maxHeight: '100px', padding: '0 10px' }}
            />
          </Link>
        </div>
      )}

      <CustomMemu
        id='Navbar'
        mode='horizontal'
        defaultSelectedKeys={[activeMenu]}
        overflowedIndicator={
          <img src={menuIcon} height='22' alt='icon hamburger menu'loading="lazy" />
        }
        onClick={onChangToMenu}
      >
        {menu?.map((item) => {
          return (
            <MenuItem id='Navbar' key={item?.key}>
              <Link to={item.key}>{item.name}</Link>
            </MenuItem>
          )
        })}
      </CustomMemu>
    </CustomHeader>
  )
}

export default HeaderComponent

const CustomHeader = styled(Header)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  display: -webkit-flex;
  -webkit-justify-content: space-between;
  background-color: transparent;
  position: fixed;
  z-index: 2;
  min-height: 130px;
  width: 100%;
  /* width: 100vw; */

  @media only screen and (max-width: 414px) {
    min-height: 80px;
    justify-content: center !important;
    -webkit-justify-content: center !important;
    padding: 0 10px !important;
  }

  &.bg {
    background-color: var(--white) !important;
  }
`

const CustomMemu = styled(Menu)`
  width: 70%;
  background-color: transparent;
  border: none;
  display: flex;
  justify-content: end;
  -webkit-justify-content: flex-end;
  display: -webkit-flex;
  align-items: center;

  @media only screen and (max-width: 414px) {
    justify-content: center !important;
    -webkit-justify-content: center !important;
    width: 100% !important;
  }

  &.bg {
    background-color: var(--white) !important;
  }

  .ant-menu-sub {
    background-color: var(--white) !important;
  }

  .ant-menu-item-selected {
    background-color: transparent !important;

    span a {
      border-bottom: 3px solid var(--secondary);
    }
  }
`

const MenuItem = styled(Menu.Item)`
  background: transparent !important;
  color: var(--black) !important;
  border: none !important;
  top: 0 !important;
  margin-bottom: 0px !important;
  margin-top: 0px !important;
  font-size: 18px;

  @media only screen and (min-width: 820px) {
    font-size: 20px;
  }


  @media only screen and (min-width: 1440px) {
    font-size: 22px;
  }
  
  line-height: 35px;
  font-family: 'Noto Sans Thai Bold';

  &.bg {
    background-color: var(--white) !important;
  }

  .ant-menu-title-content {
    color: var(--black) !important;
  }

  &:hover {
    span a {
      color: var(--secondary) !important;
    }

    background-color: transparent !important;
  }

  span a {
    color: var(--black) !important;
  }
`
